'use client';

import React from 'react';
import cn from 'classnames';
import { LogoDealVDRHorizontal } from '@dealroadshow/uikit-logo/DealVDR/Horizontal';
import { usePathname } from '@framework/next/navigation';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import Button from '@dealroadshow/uikit-button';
import Header from '@framework/ui/Pages/Landing/Sections/Header';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import Footer from './components/Footer';
import DataroomTenantContext from '@dataroom/tenant/DataroomTenantContext';
import config from '@/dataroom/app/config/config';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dmPortalUrl from '@dm-portal/url';
import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import styles from './tenantDealvdrStyles.module.scss';

interface IProps {
  children: React.ReactNode,
}

const getHeaderMenu = (pathname: string) => [
  {
    key: 'features',
    title: 'Features',
    path: '/features',
    isActive: () => pathname.startsWith('/features'),
  },
  {
    key: 'customers',
    title: 'Customers',
    path: '/customers',
  },
];

const TenantDealvdr = ({ children }: IProps) => {
  const tenant = config.tenant.tenantDealvdr.code;
  const pathname = usePathname();

  const loginUrl = useLoginUrlWithConsent(() =>
    dataroomUrl(tenant).getLoginUrl(dmPortalUrl.getUrl(`/${ tenant }`)),
  );

  return (
    <DataroomTenantContext tenant={ tenant }>
      <Header
        logoComponent={ LogoDealVDRHorizontal }
        menu={ getHeaderMenu(pathname) }
        customLoginButton={ ({
          buttonProps,
          linkProps,
        }) => (
          <NextNavLink
            { ...linkProps }
            to={ loginUrl }
          >
            <Button { ...buttonProps } />
          </NextNavLink>
        ) }
        headerButton={ ({ buttonProps }) => (
          <NextNavLink
            to="/get-a-quote"
            dataTest="getAQuote"
          >
            <Button
              { ...buttonProps }
              title="Get a Quote"
              dataTest="tenantDealvdrGetQuoteButton"
            />
          </NextNavLink>
        ) }
        mobileMenuClassName={ styles.mobileMenu }
      />
      <div className={ cn(styles.pageContainer, stickyFooterStyles.pageContainerWithStickyFooter) }>
        <ScrollBodyBackground tenant={ tenant } minHeight={ 1000 } />
        { children }
      </div>
      <Footer tenant={ tenant } />
      <CookiesBanner />
    </DataroomTenantContext>
  );
};

export default TenantDealvdr;
